var $ = require('jquery');
window.jQuery = $;
window.$ = $;
var gsap = require('gsap');
var TimeLineMax = require('gsap/src/uncompressed/TimelineMax');
require( './sass/main.scss' );

$(function() {

    TweenMax.to('.air', 1, {strokeDashoffset:-32, repeat: -1, ease:Linear.easeNone});

    var rendererOptions = {
        antialiasing: false,
        transparent: false,
        autoResize:true,
        interactive:true
    };

    var container_chimney_one_offset = -60;
    var container_chimney_two_offset = 20;
    var car_offset = -300;
    var van_offset = 180;
    var sun_offset = -200;
    var isMob;
    var cta_timeout;
    var can_interact;
    var current_scene = 1;
    var ratio_size;
    var intro_finished;
    var air = $('.air');

    var el_smoke, smokestacks, city, container, renderer, el_chimney, el_chimney2,
        container_chimney_one, container_chimney_two, car, van, sun, arr_cta;

    var wrapper = $('#wrapper');
    
    renderer = PIXI.autoDetectRenderer(wrapper.width(), 460, rendererOptions);
    renderer.backgroundColor = 0x4FC1DA;
    document.getElementById('scene').appendChild(renderer.view);

    var stage = new PIXI.Container();
    stage.interactive = true;

    container = new PIXI.Container();
    stage.addChild(container);

    var container_front = new PIXI.Container();
    stage.addChild(container_front);
    var container_man = new PIXI.Container();
    stage.addChild(container_man);
    var container_cta = new PIXI.Container();
    stage.addChild(container_cta);

    el_smoke =  PIXI.Sprite.fromImage('_assets/smoke.png');
    el_smoke.anchor.set(0.5, 0);
    el_smoke.position.x = wrapper.width() / 2;
    container.addChild(el_smoke);

    smokestacks =  PIXI.Sprite.fromImage('_assets/smokestacks.png');
    smokestacks.anchor.set(0.5, 0);
    smokestacks.position.x = wrapper.width() / 2;
    container_front.addChild(smokestacks);

    city =  PIXI.Sprite.fromImage('_assets/city.png');
    city.anchor.set(0.5, 0);
    city.position.x = wrapper.width() / 2;
    container_front.addChild(city);

    el_chimney =  PIXI.Sprite.fromImage('_assets/chimney1.png');
    el_chimney.anchor.set(0.5, 0);
    el_chimney.scale.x = el_chimney.scale.y = 0.5;
    el_chimney.position.y = 120;
    el_chimney2 =  PIXI.Sprite.fromImage('_assets/chimney1.png');
    el_chimney2.anchor.set(0.5, 0);
    el_chimney2.scale.x = el_chimney2.scale.y = 0.5;
    el_chimney2.position.y = 120;

    var f1 =  addCloud();
    var f2 =  addCloud();
    var f3 =  addCloud();
    var f4 =  addCloud();
    var f5 =  addCloud();
    var f6 =  addCloud();
    var f7 =  addCloud();
    var f8 =  addCloud();

    container_chimney_one = new PIXI.Container();
    container_chimney_one.addChild( f1 );
    container_chimney_one.addChild( f2 );
    container_chimney_one.addChild( f3 );
    container_chimney_one.addChild( f4 );
    container_chimney_one.addChild(el_chimney);
    container_chimney_one.position.x = (wrapper.width() / 2) + container_chimney_one_offset + 100;
    container_chimney_one.position.y = 110;

    container_chimney_two = new PIXI.Container();
    container_chimney_two.addChild( f5 );
    container_chimney_two.addChild( f6 );
    container_chimney_two.addChild( f7 );
    container_chimney_two.addChild( f8 );
    container_chimney_two.addChild(el_chimney2);
    container_chimney_two.position.x = (wrapper.width() / 2) + container_chimney_two_offset + 120;
    container_chimney_two.position.y = 57.5;
    container_chimney_two.scale.x = container_chimney_two.scale.y = 1.2;

    createTimeline(f1, 0);
    createTimeline(f2, 0.25);
    createTimeline(f3, 0.5);
    createTimeline(f4, 0.75);
    createTimeline(f5, 0);
    createTimeline(f6, 0.25);
    createTimeline(f7, 0.5);
    createTimeline(f8, 0.75);

    function createTimeline(obj, p) {
        var tl = new TimeLineMax({onComplete:createTimeline, onCompleteParams:[obj, 0]});
        tl.set(obj.position, {y: 100, x: 0});
        tl.set(obj, {alpha: 1});
        tl.set(obj.scale, {x: 0.1, y: 0.1});
        tl.to(obj.position, 8, {y: 10, x: 60, ease: Linear.easeNone}, 0);
        tl.to(obj.scale, 3, {x: 0.37, y: 0.37, ease: Linear.easeNone}, 0);
        tl.to(obj.scale, 4, {x: 0,y: 0, ease: Linear.easeNone}, 3);
        tl.to(obj, 0.2, {alpha: 0}, 6);
        tl.progress(p);
    }

    car =  PIXI.Sprite.fromImage('_assets/car.png');
    car.anchor.set(0, 0);
    car.position.x = -200
    car.position.y = 330;
    car.scale.x = car.scale.y = 0.4;
    container_front.addChild(car);
    van =  PIXI.Sprite.fromImage('_assets/van.png');
    van.anchor.set(0, 0);
    van.position.x = wrapper.width();
    van.position.y = 300;
    van.scale.x = van.scale.y = 0.4;
    container_front.addChild(van);
    sun =  PIXI.Sprite.fromImage('_assets/sun.png');
    sun.anchor.set(0, 0);
    sun.position.x = (wrapper.width() / 2) + sun_offset;
    sun.position.y = 60;
    sun.scale.x = sun.scale.y = 0.4;
    container_front.addChild(sun);

    man =  PIXI.Sprite.fromImage('_assets/man.png');
    man.anchor.set(0.5, 0);
    man.position.x = (wrapper.width() / 2);
    man.position.y = 60;
    man.scale.x = man.scale.y = 0.5;
    container_man.addChild(man);
    container_man.alpha = 0;

    container_front.addChild(container_chimney_one);
    container_front.addChild(container_chimney_two);

    var displacementSprite = PIXI.Sprite.fromImage('_assets/cloud.png');
    var displacementFilter = new PIXI.filters.DisplacementFilter(displacementSprite);
    stage.addChild(displacementSprite);

    container.filters = [displacementFilter];

    displacementFilter.scale.x = 10;
    displacementFilter.scale.y = 10;
    stage.scale.x = stage.scale.y = 1;
    resizeViewport();

    /**
     * Intro
     */
    TweenMax.from(city.position, 4, {x: (wrapper.width() / 2) + 100});
    TweenMax.from(smokestacks.position, 4, {x: (wrapper.width() / 2) + 40});
    TweenMax.from(el_smoke.position, 4, {x: (wrapper.width() / 2) + 40});
    TweenMax.to(container_chimney_one.position, 4, {x: (wrapper.width() / 2) + container_chimney_one_offset});
    TweenMax.to(container_chimney_two.position, 4, {x: (wrapper.width() / 2) + container_chimney_two_offset, onComplete: function() {
        // finish intro
        resize();
        showCTA(1);
        can_interact = true;
    }});
    TweenMax.to(car.position, 4, {ease: Quad.easeOut, x: (wrapper.width() / 2) + car_offset});
    TweenMax.to(van.position, 4, {ease: Quad.easeOut, x: (wrapper.width() / 2) + van_offset});


    arr_cta = [];
    arr_cta2 = [];
    setTimeout( function() {
        arr_cta.push(
            createCta( sun, 60, 30, 'rtl', 'Ozone', 0xffffff, $('#s1-l1'), $('.label--sun') ),
            createCta( container_chimney_one, -50, 70, 'ltr', 'Metals', 0xffffff, $('#s1-l2'), $('.label--chimney1') ),
            createCta( container_chimney_two, -43, 280, 'ltr', 'Sulphur\ndioxide', 0x484f53, $('#s1-l3'), $('.label--chimney2') ),
            createCta( van, -10, 110, 'ltr', 'Particulate matter (PM)', 0xffffff, $('#s1-l4'), $('.label--van') ),
            createCta( car, 20, 40, 'up_left', 'Nitrogen dioxide', 0xffffff, $('#s1-l5'), $('.label--car') )
        );

        arr_cta2.push(
            createCta( man, -10, 25, 'up_left', 'Brain', 0x484f53, $('#s2-l1'), $('.label--brain') ),
            createCta( man, 10, 260, 'rtl', 'Heart', 0x484f53, $('#s2-l2'), $('.label--heart') ),
            createCta( man, -30, 250, 'up_left', 'Lung', 0x484f53, $('#s2-l3'), $('.label--lung') ),
            createCta( man, -30, 370, 'ltr', 'Pancreas', 0x484f53, $('#s2-l4'), $('.label--pancreas') )
        );
    }, 2000);

    container_cta.alpha = 1;

    function createCta(obj, x, y, type, label, col, targ, label) {

        var cta_obj = {};
        var cta_line;
        switch(true) {
            case (obj == container_chimney_two):
                cta_line =  PIXI.Sprite.fromImage('_assets/cta_line_short.png');
                break;
            case (obj == man):
                cta_line =  PIXI.Sprite.fromImage('_assets/cta_line_purple.png');
                break;
            default:
                cta_line =  PIXI.Sprite.fromImage('_assets/cta_line.png');
                break;
        }

        cta_line.anchor.set(0, 0);
        cta_line.position.x = 10;
        cta_line.position.y = 10;
        cta_line.scale.x = cta_line.scale.y = 0.2;

        var cta = new PIXI.Container();
        cta.addChild(cta_line);

        var cta_circ;
        if (obj == man) {
            cta_circ =  PIXI.Sprite.fromImage('_assets/circ_pu.png');
        } else {
            cta_circ =  PIXI.Sprite.fromImage('_assets/circ_or.png');
        }

        cta_circ.anchor.set(0, 0);
        cta_circ.position.x = 66;
        cta_circ.position.y = 5;
        cta_circ.scale.x = cta_circ.scale.y = 1;
        cta.addChild(cta_circ);

        switch (type){
            case 'up_left':
                cta_line.rotation = 1.5708;
                cta_line.position.x = -10;
                cta_line.position.y = 10;
                cta_circ.position.x = -16;
                cta_circ.position.y = 5;
                break;
        }

        cta.position.x = obj.position.x + x;
        cta.position.y = obj.position.y + y;
        cta.alpha = 0;
        cta_obj.container = cta;
        cta_obj.offset = x;
        cta_obj.pos = {x: x, y:y};
        cta_obj.obj = obj;
        cta.label = label;
        var text = new PIXI.Text(label,{font : '16px TextSans', fill : col, align : 'center'});
        text.buttonMode = true;
        //cta.addChild(text);
        text.position.y = -3;
        switch (type){
            case 'rtl':
                cta_circ.position.x = -8;
                text.position.x = 70;
                break;
            case 'ltr':
                text.position.x = -(text.width);
                break;
            case 'up_left':
                text.position.x = 0;
                text.position.y = 50;
                break;
        }

        container_cta.addChild( cta );
        return cta_obj;
    }

    animate();
    function addCloud() {
        var cloud =  PIXI.Sprite.fromImage('_assets/circ.png');
        cloud.anchor.set(0.5, 0.5);
        cloud.position.x = 0;
        cloud.scale.x = cloud.scale.y = 0.3;
        return cloud
    }

    function animate()
    {
        renderer.render(stage);
        requestAnimationFrame(animate);
        displacementSprite.position.y -= 1;
    }

    var doit;
    window.onresize = function(){
        clearTimeout(doit);
        doit = setTimeout(resize, 60);
    };

    function resizeViewport() {
        if (wrapper.outerWidth() < 600) {
            var aspect = clamp((wrapper.width() / 768), 0.5, 1);
            renderer.resize(wrapper.width(), (768 * aspect));
            stage.pivot.x = -150;
            $('.scene__air').hide();
        } else {
            var aspect = clamp((wrapper.width() / 460), 0.5, 1);
            renderer.resize(wrapper.width(), (460 * aspect));
            stage.pivot.x = 0;
            $('.scene__air').show();
        }
        ratio_size = aspect;
        stage.scale.x = stage.scale.y = ratio_size;
        container.scale.x = container.scale.y = 1;
        $('#scene').height((460 * ratio_size));

    }
    function resize() {
        resizeViewport();
        sun.position.x = (wrapper.width() / 2) + (sun_offset);

        if (current_scene == 1) {
            container_chimney_one.position.x = (wrapper.width() / 2) + (container_chimney_one_offset);
            container_chimney_two.position.x = (wrapper.width() / 2) + (container_chimney_two_offset);
            car.position.x = (wrapper.width() / 2) + (car_offset);
            van.position.x = (wrapper.width() / 2) + (van_offset);
        }
        el_smoke.position.x = wrapper.width() / 2;
        smokestacks.position.x = wrapper.width() / 2;
        city.position.x = wrapper.width() / 2;
        man.position.x = (wrapper.width() / 2);

        if (current_scene == 1) {
            TweenMax.to($('.label--s1'), 0.5, {alpha:1, delay: 1.1});
        }
        if (current_scene == 2) {
            TweenMax.to($('.label--s2'), 0.5, {alpha:1, delay: 1.1});
        }
        setTimeout(function() {
            repos();
        }, 60);

    }

    function repos() {
        if (car) {
            TweenMax.set($('.label--car'), {
                x: car.worldTransform.tx + (20 * ratio_size),
                y: car.worldTransform.ty + (90 * ratio_size)
            });
        }
        if (sun) {
            TweenMax.set($('.label--sun'), {
                x: sun.worldTransform.tx + (130 * ratio_size),
                y: sun.worldTransform.ty + (35 * ratio_size)
            });
        }
        if (van) {
            TweenMax.set($('.label--van'), {
                x: (van.worldTransform.tx + (-10 * ratio_size)) - $('.label--van').width(),
                y: van.worldTransform.ty + (110 * ratio_size)
            });
        }
        if (container_chimney_two) {
            TweenMax.set($('.label--chimney'), {
                x: (container_chimney_two.worldTransform.tx + (-25 * ratio_size)) - $('.label--chimney').width(),
                y: container_chimney_two.worldTransform.ty + (270 * ratio_size)
            });
        }
        if (el_smoke) {
            TweenMax.set($('.label--cloud'), {
                x: (container_chimney_one.worldTransform.tx + (-50 * ratio_size)) - $('.label--cloud').width(),
                y: container_chimney_one.worldTransform.ty + (75 * ratio_size)
            });
        }
        if (man) {
            TweenMax.set($('.label--brain'), {
                x: (man.worldTransform.tx + (-10 * ratio_size)),
                y: man.worldTransform.ty + (75 * ratio_size)
            });
            TweenMax.set($('.label--heart'), {
                x: (man.worldTransform.tx + (80 * ratio_size)),
                y: man.worldTransform.ty + (260 * ratio_size)
            });
            TweenMax.set($('.label--lung'), {
                x: (man.worldTransform.tx + (-50 * ratio_size)) - $('.label--lung').width(),
                y: man.worldTransform.ty + (300 * ratio_size)
            });
            TweenMax.set($('.label--pancreas'), {
                x: (man.worldTransform.tx + (20 * ratio_size)) - $('.label--pancreas').width(),
                y: man.worldTransform.ty + (350 * ratio_size)
            });
        }

        for (var i=0; i < arr_cta.length; i++) {
            arr_cta[i].container.position.x = arr_cta[i].obj.position.x + arr_cta[i].offset;
        }
        for (var i=0; i < arr_cta2.length; i++) {
            arr_cta2[i].container.position.x = arr_cta2[i].obj.position.x + arr_cta2[i].offset;
        }
    }

    var mqls = [
        window.matchMedia("(max-width: 480px)"),
        window.matchMedia("(max-width: 640px)"),
        window.matchMedia("(min-width: 641px)")
    ];

    function mediaqueryresponse(mql) {
        switch (true) {
            case (mqls[0].matches):

                break;
            case (mqls[1].matches):
                isMob = false;

                break;
            case (mqls[2].matches):

                break;
            default:

                break;
        }
    }

    for (var i = 0; i < mqls.length; i++) {
        mediaqueryresponse(mqls[i]);
        mqls[i].addListener(mediaqueryresponse.bind(this));
    }

    $('.tab-navigation__option--pollutants').click(function() {

        if (!can_interact || current_scene == 1) return;
        $('.content-list__pollutants').fadeIn();
        $('.content-list__health').hide();
        $('.tab-navigation__option--pollutants').addClass('tab-navigation__option--pollutants--selected');
        $('.tab-navigation__option--health').removeClass('tab-navigation__option--health--selected');
        $('.tab-navigation__hilite--health').fadeOut();
        $('.tab-navigation__hilite--pollutants').fadeIn();
        current_scene = 1;
        clearTimeout(cta_timeout);

        transitionInSceneOne();
        transitionOutSceneTwo();
        can_interact = false;
    });
    $('.tab-navigation__option--health').click(function() {
        if (!can_interact || current_scene == 2) return;
        current_scene = 2;
        $('.content-list__health').fadeIn();
        $('.content-list__pollutants').hide();
        $('.tab-navigation__option--pollutants').removeClass('tab-navigation__option--pollutants--selected');
        $('.tab-navigation__option--health').addClass('tab-navigation__option--health--selected');
        $('.tab-navigation__hilite--health').fadeIn();
        $('.tab-navigation__hilite--pollutants').fadeOut();

        clearTimeout(cta_timeout);

        transitionOutSceneOne();
        transitionInSceneTwo();
        can_interact = false;
    });
    function transitionInSceneOne() {
        TweenMax.to(car.position, 1.2, {ease: Quad.easeOut, x: (wrapper.width() / 2) + car_offset});
        TweenMax.to(van.position, 1, {ease: Quad.easeOut, x: (wrapper.width() / 2) + van_offset});

        TweenMax.to(container_chimney_one.position, 1, {ease: Quad.easeOut, x: (wrapper.width() / 2) + container_chimney_one_offset});
        TweenMax.to(container_chimney_two.position, 1, {ease: Quad.easeOut, x: (wrapper.width() / 2) + container_chimney_two_offset});

        TweenMax.to(city.position, 3, {x: (wrapper.width() / 2)});
        TweenMax.to(smokestacks.position, 3, {x: (wrapper.width() / 2)});
        TweenMax.to(el_smoke.position, 3, {x: (wrapper.width() / 2)});

        setTimeout(function() {
            can_interact = true;
            showCTA(1);
        }, 1000);
    }
    function transitionOutSceneOne() {
        TweenMax.to(car.position, 2, {ease: Quad.easeOut, x: -500});
        TweenMax.to(van.position, 2, {ease: Quad.easeOut, x:-400});
        TweenMax.to(container_chimney_one.position, 3, {ease: Quad.easeOut, x:-300});
        TweenMax.to(container_chimney_two.position, 3, {ease: Quad.easeOut, x:-300});

        TweenMax.to(city.position, 4, {x: (wrapper.width() / 2) - 50});
        TweenMax.to(smokestacks.position, 4, {x: (wrapper.width() / 2) - 50});
        TweenMax.to(el_smoke.position, 4, {x: (wrapper.width() / 2) - 50});
        hideCTA(1);
    }
    function transitionInSceneTwo() {
        TweenMax.set(container_man.scale, {x: 1.5, y:1.5});
        TweenMax.to(container_man.scale, 1, {x: 1, y:1});
        TweenMax.to(container_man, 1, {alpha: 1});
        TweenMax.to($(".scene__air"), 1, {alpha: 1, delay:1});
        showCTA(2);
        setTimeout(function() {
            can_interact = true;
        }, 1000);

    }
    function transitionOutSceneTwo() {
        TweenMax.to(container_man, 1, {alpha: 0});
        TweenMax.to($(".scene__air"), 1, {alpha: 0});
        hideCTA(2);
    }

    function hideCTA(id) {
        if (id == 1) {
            for (var i = 0; i < arr_cta.length; i++) {
                TweenMax.set(arr_cta[i].container, {alpha: 0});
                TweenMax.killDelayedCallsTo(arr_cta[i].container);
                TweenMax.killDelayedCallsTo($('.label--s1'));
                TweenMax.to($('.label--s1'), 0.4, {alpha: 0});
            }
        }

        if (id == 2) {
            for (var i = 0; i < arr_cta2.length; i++) {
                TweenMax.set(arr_cta2[i].container, {alpha: 0});
                TweenMax.killDelayedCallsTo(arr_cta2[i].container);
                TweenMax.killDelayedCallsTo($('.label--s2'));
                TweenMax.to($('.label--s2'), 0.4, {alpha: 0});
            }
        }

    }
    function showCTA(id) {
        if (id == 1) {
            for (var i = 0; i < arr_cta.length; i++) {
                TweenMax.to(arr_cta[i].container, .3, {alpha: 1, delay: 1});
                TweenMax.to($('.label--s1'), 0.5, {alpha:1, delay: 1.1});
            }
        }
        if (id == 2) {
            for (var i = 0; i < arr_cta2.length; i++) {
                TweenMax.to(arr_cta2[i].container, .3, {alpha: 1, delay:1});
                TweenMax.to($('.label--s2'), 0.5, {alpha:1, delay: 1.1});
            }
        }
        setTimeout(function() {
            repos();
        }, 1000);
    }

    function clamp(num, min, max) {
        return num < min ? min : num > max ? max : num;
    }

    function scrollTo(el) {
        var currentScroll = $(window).scrollTop();
        var scrollObj = {top:currentScroll};
        TweenMax.to(scrollObj, 1.5, {top:el.position().top, ease:Quad.easeOut, onUpdate: function() {
            $(window).scrollTop((scrollObj.top)-20);
        }});
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./app/main.js
 ** module id = 0
 ** module chunks = 0
 **/